import styled from 'styled-components';
import { Text } from '@awazevr/design-system.components.text';
import { Button } from '@awazevr/design-system.components.button';

export const StyledTitle = styled(Text)`
  ${({ theme }) => theme.fonts.Heading100}
  margin-bottom: 2rem;
`;

export const StyledContent = styled(Text)`
  margin-bottom: 2rem;
`;

export const StyledButton = styled(Button)`
  ${({ theme }) => theme.mediaQueries.phoneDS} {
    width: 100%;
  }
`;
